
const NAV_LINKS = {
  DASHBOARD: 'Dashboard',
  PARTICIPATION: 'Participation',
  DEVOTEES: 'Devotees',
  DEVOTIONAL_GROUPS: 'Devotional Groups',
  // CHECKLISTS: 'Checklists',
};

const ADMIN_LINKS = {
  ADMIN: 'Admin',
  // PARISHES: 'Parishes',
  // EDUCATION: 'Education',
};

const ROUTES = {
  [NAV_LINKS.DASHBOARD]: 'dashboard',
  [NAV_LINKS.PARTICIPATION]: 'participation',
  [NAV_LINKS.DEVOTEES]: 'devotees',
  [NAV_LINKS.DEVOTIONAL_GROUPS]: 'devotionalGroups',
  [ADMIN_LINKS.ADMIN]: 'admin',
  // [NAV_LINKS.CHECKLISTS]: 'checklists',
  // [ADMIN_LINKS.PARISHES]: 'parishes',
  // [ADMIN_LINKS.EDUCATION]: 'education',
};

const NAV_LINKS_LIST = Object.values(NAV_LINKS);
const ADMIN_LINKS_LIST = Object.values(ADMIN_LINKS);
const TIME = {
  DAYS_IN_WEEK: 7, // 7 days
};

export {
  ADMIN_LINKS,
  NAV_LINKS,
  NAV_LINKS_LIST,
  ADMIN_LINKS_LIST,
  ROUTES,
  TIME,
};
